module.exports = __webpack_public_path__ + "assets/img/webinar-logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/webinar-logo.jpg
// module id = 1992
// module chunks = 0